import { type FC } from 'react';
import ThirdPartyLinkButton from './ThirdPartyLinkButton';

interface SourceLinksListProps {
  urlList?: string[];
}
const SourceLinksList: FC<SourceLinksListProps> = ({ urlList }) => {
  return (
    <div className="flex gap-2">
      {urlList?.map((url) => {
        return <ThirdPartyLinkButton key={url} url={url} />;
      })}
    </div>
  );
};

export default SourceLinksList;
